import React from "react";
import { useQuery } from "@apollo/react-hooks";
import styled from "styled-components";
import PropTypes from "prop-types";

import Hidden from "core/Hidden";
import LoadingSpinner from "core/LoadingSpinner";
import Icon from "./Icon";

import colors from "core/colors";
import {
    OuterContainer,
    InnerContainer,
    RowContainer,
    IconRow,
    InnerRowContainer,
    IconsLandingPageMobileConstraintImg,
    RowFlex
} from "./styles";

import spacerImg from "./images/spacer.gif";

import { GET_ICONS_HOMEPAGE, GET_ICONS_ICONSPAGE } from "./queries";

import { getIconsArrays } from "./helpers";

import { useViewport } from "js/hooks/useViewport";

const UnstyledHeroClickableIcons = ({ className, isHomepage = true }) => {
    const { browserWidth } = useViewport();

    const chooseQuery = isHomepage ? GET_ICONS_HOMEPAGE : GET_ICONS_ICONSPAGE;

    const { loading, data } = useQuery(chooseQuery, {
        fetchPolicy: "cache-and-network"
    });

    if (loading) {
        return (
            <OuterContainer className={className} isHomepage={isHomepage}>
                <LoadingSpinner
                    loadingColor={colors.primary.snow}
                    iconSize="xl"
                    hideText
                />
            </OuterContainer>
        );
    }

    const { heroIcons } = data;

    const allIcons = isHomepage
        ? heroIcons.homePage.items
        : heroIcons.iconLandingPage.items;

    const arraysOfIcons = getIconsArrays({
        allIcons,
        isHomepage,
        browserWidth
    });

    return (
        <OuterContainer className={className} isHomepage={isHomepage}>
            <InnerContainer isHomepage={isHomepage}>
                {!isHomepage && (
                    <Hidden breakpoint="mdLg">
                        <IconsLandingPageMobileConstraintImg
                            src={spacerImg}
                            alt=""
                        />
                    </Hidden>
                )}

                <RowContainer isHomepage={isHomepage}>
                    <RowFlex isHomepage={isHomepage}>
                        {arraysOfIcons.map((row, index) => {
                            return (
                                <IconRow key={index} isHomepage={isHomepage}>
                                    <InnerRowContainer isHomepage={isHomepage}>
                                        {arraysOfIcons[index].map(
                                            (icon, idx) => {
                                                return (
                                                    <Icon
                                                        key={idx}
                                                        icon={icon}
                                                        isHomepage={isHomepage}
                                                    />
                                                );
                                            }
                                        )}
                                    </InnerRowContainer>
                                </IconRow>
                            );
                        })}
                    </RowFlex>
                </RowContainer>
            </InnerContainer>
        </OuterContainer>
    );
};

const HeroClickableIcons = styled(UnstyledHeroClickableIcons)``;

HeroClickableIcons.propTypes = {
    isHomepage: PropTypes.bool
};

export default HeroClickableIcons;
